import { AddOn } from "../interfaces/AddOn";

export const isAddOnSubscribed = (addOn?: AddOn): boolean => {
  return (
    !!addOn &&
    !!addOn.associatedSubscription &&
    addOn.associatedSubscription.subscribed
  );
};

export const getAssociatedSubscriptionId = (addOn?: AddOn): number => {
  const notFound = -1;
  return (
    (addOn &&
      addOn.associatedSubscription &&
      addOn.associatedSubscription.id) ||
    notFound
  );
};
